export const sendWhatsappMessage = (message:string) => {
  const phoneNumber = "971567729666"; // Replace with the desired phone number

  const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
    message
  )}`;
  window.open(url);
};
